import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { privateRequest } from "../../api/apiConfig/privateRequest";
import Loader from "../loader/Loader";
import "./RoleSetting.scss";
import Switch from "react-switch";

const RoleSetting = () => {
  const id = useParams();
  const [roledata, setRoleData] = useState([]);
  const [permissionID, setPermissionID] = useState([]);
  const [IsChecked, setIsChecked] = useState([]);
  const [entityID, setEntityID] = useState([]);
  const [flatData, setFlatData] = useState([]);
  const getRole = async () => {
    const { data } = await privateRequest.get(`/role/permission/${id.id}`);
    setRoleData(data.data.entity);
    getEntityId(data.data.entity);
  };
  const getEntityId = (entitydata) => {
    let idWithName = [];
    let entId = [];
    entitydata.map((data) => {
      idWithName.push({ [data.id]: data.permissions.map((temp) => temp.id) });
      entId.push(data.id);
    });
    const object = entitydata.reduce(
      (a, data) => ({
        ...a,
        [data.id]: data.permissions.map((temp) => temp.id),
      }),
      {}
    );
    const falt = [];
    const flat = [];

    idWithName.map((rem, i) => {
      let id = entId[i];
      falt.push(rem[id]);
    });
    flat.push(falt.flatMap((data) => data));
    setFlatData(flat.flatMap((data) => data));
    setEntityID(idWithName);
  };

  const handleActivePermission = (e, entityId) => {
    for (let index = 0; index < roledata.length; index++) {
      if (roledata[index].id == entityId) {
        roledata[index].isSelected = e;
        for (let j = 0; j < roledata[index].permissions.length; j++) {
          roledata[index].permissions[j].isSelected = e;
        }
      }
    }
    setRoleData([...roledata]);
    const permissionId = [];
    roledata.map((data) =>
      data.permissions
        .filter((temp) => temp.isSelected === true)
        .map((id) => permissionId.push(id.id))
    );
    setPermissionID(permissionId);
  };
  const handlecheck = (e, pId, eId) => {
    for (let index = 0; index < roledata.length; index++) {
      if (roledata[index].id == eId) {
        if (e) {
          roledata[index].isSelected = true;
        }
        for (let j = 0; j < roledata[index].permissions.length; j++) {
          if (roledata[index].permissions[j].id == pId) {
            roledata[index].permissions[j].isSelected = e;
          }
        }
        const isTrue = roledata[index].permissions.find(
          (ele) => ele.isSelected
        );
        roledata[index].isSelected = isTrue ? true : false;
      }
    }
    setRoleData([...roledata]);
    const permissionId = [];
    roledata.map((data) =>
      data.permissions
        .filter((temp) => temp.isSelected === true)
        .map((id) => permissionId.push(id.id))
    );
    setPermissionID(permissionId);
  };
  useEffect(() => {
    getRole();
  }, []);
  return (
    <div className="roletab">
      <div className="roleSetting">
        {roledata.length === 0 ? (
          <div>
            <Loader />
          </div>
        ) : (
          roledata.map((entity) => (
            <div key={entity.id} className="roleSetting_container">
              <div className="entity">
                <span className="entity_title">{entity.entityName}</span>
                <span className="entity_switching">
                  <Switch
                    className="entity_switch"
                    checked={entity.isSelected}
                    size="xs"
                    onChange={(e) => handleActivePermission(e, entity.id)}
                    onstyle="info"
                    onColor="#86d3ff"
                    onHandleColor="#2693e6"
                    handleDiameter={18}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={15}
                    width={35}
                    id="material-switch"
                  />
                </span>
                <span className="entity_check">
                  {entity.permissions.map((permission) => (
                    <span className="span-check" key={permission.id}>
                      <input
                        type="checkbox"
                        className="entity_check_box"
                        checked={permission.isSelected}
                        onChange={(e) =>
                          handlecheck(
                            e.target.checked,
                            permission.id,
                            entity.id
                          )
                        }
                        name="check"
                        id={`${permission.actionName}${permission.id}`}
                      />
                      <label
                        style={{ margin: "0px" }}
                        htmlFor={`${permission.actionName}${permission.id}`}
                      >
                        {permission.actionName}
                      </label>
                    </span>
                  ))}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RoleSetting;
